import _get from 'lodash/get'

export const eventAdapter = data => {
  const event = {
    ...data,
    ..._get(data, 'attributes', {}),
    self: _get(data, 'relationships.self.data', {}),
    owner: _get(data, 'relationships.owner.data', {}),
  }
  delete event.attributes
  delete event.relationships
  return event
}

export const scheduledMessagesAdapter = data => {
  const res = _get(data, 'data.$original.schedule_mailouts', [])
  return res
}

export const scheduledInvitationsAdapter = data => {
  const res = _get(data, 'data.$original.invitations', [])
  return res
}